// extracted by mini-css-extract-plugin
module.exports = {"AuthorizationTable":"AuthorizationTable_Y3C3z"};